import { render, staticRenderFns } from "./kdxContentBar.g.vue?vue&type=template&id=72ff21cc&scoped=true"
import script from "./kdxContentBar.g.vue?vue&type=script&lang=js"
export * from "./kdxContentBar.g.vue?vue&type=script&lang=js"
import style0 from "./kdxContentBar.g.vue?vue&type=style&index=0&id=72ff21cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff21cc",
  null
  
)

export default component.exports